(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.cs-section[data-cross-sell]');
    if (sections.length === 0) return;

    function findProductForm(csSection) {
      // 1. Try standard Shopify selectors
      const candidates = document.querySelectorAll('form[action*="/cart/add"]');
      for (const f of candidates) {
        if (!f.contains(csSection) && !csSection.contains(f)) return f;
      }
      return candidates[0] || null;
    }

    function formatMoney(cents) {
      const v = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return v + ' €';
    }

    sections.forEach(function (csSection) {
      const form = findProductForm(csSection);
      if (!form) return;

      const checkboxes = csSection.querySelectorAll('.cs-checkbox');
      const summary = csSection.querySelector('[data-summary]');
      const summaryCount = csSection.querySelector('[data-count]');
      const summaryTotal = csSection.querySelector('[data-total]');
      const redirect = csSection.dataset.redirect === 'true';

      // Live summary
      function updateSummary() {
        if (!summary) return;
        let count = 0;
        let total = 0;
        checkboxes.forEach(function (cb) {
          if (cb.checked) {
            count++;
            // Price is exposed via dataset on parent? Use closest .cs-price-current text
            const price = cb.closest('.cs-row')?.querySelector('.cs-price-current')?.textContent || '';
            const num = parseFloat(price.replace(/[^\d,.-]/g, '').replace('.', '').replace(',', '.'));
            if (!isNaN(num)) total += num * 100;
          }
        });
        summary.hidden = count === 0;
        if (summaryCount) summaryCount.textContent = count;
        if (summaryTotal) summaryTotal.textContent = formatMoney(total);
      }
      checkboxes.forEach(function (cb) { cb.addEventListener('change', updateSummary); });

      // Hook form submit — capture phase so we run before theme JS
      form.addEventListener('submit', async function (e) {
        const checked = csSection.querySelectorAll('.cs-checkbox:checked');
        if (checked.length === 0) return; // normal submit, no intercept

        e.preventDefault();
        e.stopImmediatePropagation();

        const formData = new FormData(form);
        const mainVariantId = formData.get('id');
        const mainQty = parseInt(formData.get('quantity') || '1', 10);

        const items = [{ id: parseInt(mainVariantId, 10), quantity: mainQty }];

        // Pass through any line item properties
        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            items[0].properties = items[0].properties || {};
            const propKey = key.match(/properties\[(.*)\]/)?.[1];
            if (propKey) items[0].properties[propKey] = value;
          }
        }

        checked.forEach(function (cb) {
          items.push({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 });
        });

        // Submit button → loading state
        const submitBtn = form.querySelector('[type="submit"]');
        const originalText = submitBtn?.innerHTML;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Hinzufügen fehlgeschlagen');
          }

          // Trigger theme cart refresh — try common events
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          window.dispatchEvent(new CustomEvent('cart:refresh'));

          // Try to open cart drawer if theme supports it
          const drawerToggle = document.querySelector('[data-cart-drawer-toggle], a[href="#cart"], .js-cart-drawer-open');
          if (drawerToggle && !redirect) {
            drawerToggle.click();
          } else {
            window.location.href = '/cart';
          }
        } catch (err) {
          console.error('[cross-sell] Add to cart failed:', err);
          alert('Konnte nicht zum Warenkorb hinzugefügt werden: ' + (err.message || err));
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
            if (originalText) submitBtn.innerHTML = originalText;
          }
        }
      }, true); // capture phase
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tesseract-assembly"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.ta-section');
    const clamp01 = (x) => Math.max(0, Math.min(1, x));
    const lerp = (a, b, t) => a + (b - a) * t;
    const smoothstep = (a, b, x) => {
      const t = clamp01((x - a) / (b - a));
      return t * t * (3 - 2 * t);
    };
    const easeInOutQuart = (x) =>
      x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;

    sections.forEach((section) => {
      const stage = section.querySelector('.ta-stage');
      const track = section.querySelector('.ta-track');
      if (!stage || !track) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const progressEl = section.querySelector('[data-progress]');
      const scaleEl = section.querySelector('[data-scale]');
      const partsEl = section.querySelector('[data-parts]');
      const caps = section.querySelectorAll('.ta-cap');
      const partsStart = parseInt(partsEl?.textContent || '23', 10);

      let ticking = false;
      const update = () => {
        ticking = false;
        const rect = track.getBoundingClientRect();
        const total = rect.height - window.innerHeight;
        const scrolled = Math.max(0, -rect.top);
        const p = clamp01(scrolled / total);

        const rot = lerp(0, 180, easeInOutQuart(p));
        const tint = 1 - smoothstep(0.55, 0.88, p);
        const annot = 1 - smoothstep(0.42, 0.7, p);
        const grid = 1 - smoothstep(0.5, 0.85, p);
        const halo = smoothstep(0.65, 0.95, p);
        const bp = 1 - smoothstep(0.4, 0.75, p);
        const bright = lerp(1, 1.65, bp);
        const contrast = lerp(1, 1.3, bp);
        const gray = lerp(0, 1, bp);
        const scale = lerp(0.88, 1.02, smoothstep(0, 0.7, p)) - smoothstep(0.85, 1, p) * 0.03;

        stage.style.setProperty('--ta-p', p);
        stage.style.setProperty('--ta-rot', rot + 'deg');
        stage.style.setProperty('--ta-tint', tint);
        stage.style.setProperty('--ta-annot', annot);
        stage.style.setProperty('--ta-grid', grid);
        stage.style.setProperty('--ta-halo', halo);
        stage.style.setProperty('--ta-scale', scale);
        stage.style.setProperty('--ta-bright', bright);
        stage.style.setProperty('--ta-contrast', contrast);
        stage.style.setProperty('--ta-gray', gray);

        let phase = 1;
        if (p > 0.32 && p < 0.72) phase = 2;
        else if (p >= 0.72) phase = 3;
        stage.setAttribute('data-phase', String(phase));
        caps.forEach((c) => c.setAttribute('data-active', c.dataset.cap === String(phase) ? '1' : '0'));

        if (progressEl) progressEl.textContent = Math.round(p * 100);
        if (scaleEl) scaleEl.textContent = '1:' + (4 - smoothstep(0, 0.7, p) * 2).toFixed(1);
        if (partsEl) partsEl.textContent = Math.max(1, Math.round(partsStart - smoothstep(0.3, 0.75, p) * (partsStart - 1)));
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
